import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import { jsPDF } from 'jspdf';
// import html2canvas from 'html2canvas'
import swal from "sweetalert2";
import 'jspdf-autotable'
import {
  Combo2Service,
  ExcelService,

  PurchaseReportService
} from "../../../services/index";
import { PurchaseOrderService } from "../../../services/purchaseorder.service";
declare var google;

@Component({
  selector: "purchaseOrder",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./PurchaseStatusReport.html",
})
export class PurchaseStatus implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  gridOptions: any;
  dataList = [];
  qualityList: any;
  typeList = ["RECEIVED", "PENDING", "BULK PENDING - ALL PARTY"];

  codeList: any;
  widthList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  finyearList = [];
  pending_data = [];
  temp_data = [];
  party = [];
  exceldata: any;
  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  coreList = ["CORE", "NEW", "BOTH"];
  colorList = ["lightblue", "pink"];
  filter = {
    groupby: "PURCHASE",
    coregroupby: "style_wise",
    party_code: "",
    party_name: "",
    fin_id: "4",
    agent: "",
    transport: "",
    color: [],
    design_no: "",
    shade: "",
    width: [],
    quality: [],
    type: "",
    sample_cut: [],
    swatch_cut: [],
    po_from_date: "",
    po_to_date: "",
    order_from: "",
    order_to: "",
    mtr_from: "",
    mtr_to: "",
    rate_from: "",
    rate_to: "",
    po_id: "",
    finyear: "",
    style: "",
    variety: "",
    party_id: ""
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "po_no",
    orderDir: "asc",
  };
  printConfig: any = {
    title: "Agent Yearly report",
    columns: [],
    rows: [],
  };

  partyList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  columns = [];
  partycodeList = [];
  toggleCol = [];
  menu: any;
  reportTypeList = ["DESIGN NO", "PARTY", "PURCHASE"];

  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  swatchList = ["YES", "NO"];
  sampList = ["YES", "NO"];
  pending_type: any;
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private excelService: ExcelService,
    private purReport: PurchaseReportService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    public toasterService: ToasterService,
    private poservice: PurchaseOrderService
  ) {
    this.filter.po_from_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.filter.po_to_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");

  }

  ngOnInit(): void {
    this.getColumns();
    this.finyearCombo();
    this.loadPartyList();
    // this.codelist();
    // this.colorlist();
    // this.widthlist();
    // this.qualitylist();
    // this.typelist();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        type: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
        headerClass: "text-center",
      },
      {
        name: "PO No",
        prop: "po_no",
        cellClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
      },
      {
        name: "Order Date",
        prop: "po_date",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        headerClass: "text-center",
      },
      {
        name: "Party Code",
        prop: "party_code",
        minWidth: 160,
        maxWidth: 160,
        width: 160,
        headerClass: "text-center",
      },
      {
        name: "Party Name",
        prop: "party_name",
        minWidth: 160,
        maxWidth: 160,
        width: 160,
        headerClass: "text-center",
      },
      {
        name: "Indent No",
        prop: "indent_no",
        cellClass: "text-right",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        headerClass: "text-center",
      },
      {
        name: "Transport",
        prop: "transport",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        headerClass: "text-center",
      },
      {
        name: "Agent",
        prop: "agent",
        cellClass: "text-right",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        headerClass: "text-center",
      },
      {
        name: "Total Amount",
        prop: "totalamt",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "No of Designs",
        prop: "no_of_design",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
    ];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };

    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }
  loadPartyList() {
    let that = this;
    this.combo2Service.purchasePartyCombo().then((res: any) => {
      that.partycodeList = res.data;
    });
  }
  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getOrderList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  exportToExcel($event) {

    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  applyFilter(): void {
    //this.filterExpand = false;
    // this.filterPanel.close();
    $("#type").blur();
    this.filter.coregroupby = "style_wise";
    this.getOrderList();
  }

  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.finyearCtrl.setValue(res.data[0].fin_id);
      that.filter.finyear = res.data[0].finyear;
    });
  }

  qualitylist() {
    this.poservice.qualitylist({}).then((res: any) => {
      this.qualityList = res.data;
    });
  }

  typelist() {
    this.poservice.typelist({}).then((res: any) => {
      this.typeList = res.data;
    });
  }
  colorlist() {
    this.poservice.colorlist({}).then((res: any) => {
      this.colorList = res.data;
    });
  }
  widthlist() {
    this.poservice.widthlist({}).then((res: any) => {
      this.widthList = res.data;
    });
  }

  onbackbutton() {
    this.filter.po_id = "";
    if (this.filter.coregroupby == "design_wise") {
      this.filter.coregroupby = "party_wise";
      this.filter.party_id = "";
    }
    else if (this.filter.coregroupby == "party_wise") {
      this.filter.coregroupby = "variety_wise";
      this.filter.variety = "";

    }
    else if (this.filter.coregroupby == "variety_wise") {
      this.filter.coregroupby = "style_wise";
      this.filter.style = "";
    }
    this.getOrderList();
  }

  onCellClick(event) {

    if (this.filter.type == "BULK PENDING - ALL PARTY") {
      return false;
    }
    let temp = event.row.po_id;
    this.filter.po_id = temp;
    if (this.filter.coregroupby == "style_wise") {
      this.filter.coregroupby = "variety_wise";
      this.filter.style = event.row.style;
    }
    else if (this.filter.coregroupby == "variety_wise") {
      this.filter.coregroupby = "party_wise";
      this.filter.style = event.row.style;
      this.filter.variety = event.row.variety;

    }
    else if (this.filter.coregroupby == "party_wise") {
      this.filter.coregroupby = "design_wise";
      this.filter.style = event.row.style;
      this.filter.variety = event.row.variety;
      this.filter.party_id = event.row.party_id;
    }

    let params = {
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    that.isLoadMask = that.purReport
      .getPurchaseStatusReport(params)
      .then(function (res: any) {

        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false,
        };

        let colorlength = that.colorList.length;

        for (let i = 0; i < res.columns.length; i++) {
          let temp = i % colorlength;
          if (i == 4 || i == 5 || i == 7 || i == 8 || i == 10 || i == 11) {
            res.columns[i].background = that.colorList[temp];
          }
          // res.data[i].background = that.colorList[temp];
        }
        that.printConfig = {
          title: "Purchase Order Report",
          columns: res.columns,
          rows: that.orderList,
        };
        that.exceldata = that.getData(res.columns, res.data);
      });
  }

  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  codelist() {
    this.poservice.codelist({}).then((res: any) => {
      this.partycodeList = res.data;
    });
  }

  getOrderList(): void {
    this.filter.po_from_date =
      this.datePipe.transform(this.filter.po_from_date, "yyyy-MM-dd");

    this.filter.po_to_date = this.datePipe.transform(
      this.filter.po_to_date,
      "yyyy-MM-dd"
    );
    //this.filter.order_to_date = this.datePipe.transform(this.filter.order_to_date, 'yyyy-MM-dd');
    let params = {
      // start: `${this.page.offset * (this.page.limit + 1)}`,
      // limit: `${this.page.limit}`,
      // page: "1",
      // orderColumn: `${this.page.orderBy}`,
      // orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };

    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.purReport
      .getPurchaseStatusReport(params)
      .then(function (res: any) {

        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;
        that.pending_data = res.data;
         that.pdfReport()
        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false,
        };
        that.printConfig = {
          title: "Purchase Order Report",
          columns: res.columns,
          rows: that.orderList,
        };
        that.exceldata = that.getData(res.columns, res.data);
      });
  }
   pdfReport() {
    if (this.filter.coregroupby == 'sample' || this.filter.coregroupby == 'bulk') {
      this.pending_data.forEach(el => {
        if (this.party.findIndex(e => e.party_code === el.party_code) === -1)
          this.party.push(el)

      })
      this.getpdfData(0)
    }
  }
  getSampleBulkPdf(type) {
    this.filter.coregroupby = type
    this.orderList = [];
    this.party = [];
    this.getOrderList()
  }
  getpdfData(ind) {
    let is_checked: boolean = false
    let temp_party = this.party[ind].party_code
    this.pending_data = this.orderList;
    this.temp_data = this.pending_data.filter(el => el.party_code == temp_party);

    if (this.temp_data.length > 0) {
      is_checked = true;
    }
    else {
      swal("PDF File Download Failed!!")
    }
    if (is_checked) {
      this.refreshPdfFile(ind)
    }


  }
  refreshPdfFile(ind) {

    var head = [];
    if (this.filter.coregroupby == "bulk") {
      head = [['S.NO', 'VARIETY', 'PARTY DESIGN', 'PO MTRS']];
      this.pending_type = 'Bulk Pending'
    }
    if (this.filter.coregroupby == "sample") {
      head = [['S.NO', 'VARIETY', 'PARTY DESIGN']];
      this.pending_type = 'Sample Pending'
    }
    var data = []
    let mtr_tot = 0;
    let shirt_tot = 0;
    this.temp_data.forEach((el, ind) => {
      if (this.filter.coregroupby == "bulk") {
        mtr_tot += Math.round(el.pend_total);
        // shirt_tot += Math.round(el.pend_shirts);

      }
      console.log(el)
      el.sno = ind + 1;
      data.push(Object.values(el))
    });
    if (this.filter.coregroupby == "bulk") {
      data.push(['', '', 'Total Mtrs', mtr_tot])
    }



    const doc = new jsPDF();

    let title = "Party Name :"+ this.party[ind].party_code
    let title2 = "Agent Name:" +this.party[ind].agent 
    let title3 = "Order No :"+ this.party[ind].book_no
     let title4 = "Order Date:"+this.party[ind].po_entry_date 
    doc.setFontSize(13);
    doc.text(title, 15, 7);
    doc.text(title2, 150, 7);
    doc.text(title3, 21, 13);
    doc.text(title4, 152, 13);

    doc.setFontSize(10);
    doc.setTextColor(100);
    if (this.filter.coregroupby == 'bulk') {
      (doc as any).autoTable({
        head: head,
        body: data,
        theme: 'striped',
        didParseCell: function (data) {
          var rows = data.table.body;
          if (data.row.index === rows.length - 1) {
            data.cell.styles.fontSize = 14;
            data.cell.styles.fontWeight = 700;

          }
        }
      })
    }
    if (this.filter.coregroupby == 'sample') {
      (doc as any).autoTable({
        head: head,
        body: data,
        theme: 'striped'
      })
    }

    let exten = this.party[ind].party_code + '('+ this.pending_type + ')';
    let temp_name = exten + '.pdf';
    doc.save(temp_name);

    setTimeout(() => {
      let index = ind + 1;
      if (index == this.party.length) {
        swal("PDF File Download Completed!!")
        this.filter.coregroupby = 'style_wise'
        this.getOrderList()
      }
      else {
        console.log(this.party, index)
        this.getpdfData(index)

      }

    }, 2000);
  }
  getData(columns, data) {

    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }

  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/newReport/PurchaseStatusReport.ts